module.exports = __webpack_public_path__ + "static/media/farming2.59e3b145.png";